<template>
  <div v-if="!isAppoinmentMode" class="tabs-filter-container order-0">
    <div
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'active' }"
      data-test-id="dashboard-active-passes-tab"
      @click="setActivePassState('active')"
    >
      <div class="filter-tab-content">Active</div>
    </div>
    <div
      v-if="shouldShowBothTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'both' }"
      data-test-id="dashboard-both-passes-tab"
      @click="setActivePassState('both')"
    >
      <div class="filter-tab-content">Active & Ended</div>
    </div>
    <div
      v-if="shouldShowEndedTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'ended' }"
      data-test-id="dashboard-ended-passes-tab"
      @click="setActivePassState('ended')"
    >
      <div class="filter-tab-content">Ended</div>
    </div>
    <div
      v-if="shouldShowQueueTab"
      class="filter-tab d-flex justify-content-center align-items-center text-center"
      :class="{ active: activePassState === 'queue' }"
      data-test-id="dashboard-queue-passes-tab"
      @click="setActivePassState('queue')"
    >
      <div class="filter-tab-content">Queue</div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue"
import { useStore } from "vuex"

export default {
  name: "DashboardStatusFiltersOld",
  setup() {
    const store = useStore()

    const activePassType = computed(
      () => store.getters["dashboardTable/getType"]
    )

    const activePassState = computed(
      () => store.getters["dashboardTable/getStatus"]
    )

    const isUserInTransparency = computed(
      () => store.getters["authentication/isUserInTransparency"]
    )

    const isAppoinmentMode = computed(() => {
      return activePassType.value.includes("appointment")
    })

    const shouldShowBothTab = computed(() => {
      return activePassType.value !== "all" || isUserInTransparency.value
    })

    const shouldShowEndedTab = computed(() => {
      return activePassType.value !== "all" || isUserInTransparency.value
    })

    const isQueueModuleActive = computed(() => {
      return store.getters["queueSettings/isQueueModuleActive"]
    })

    const shouldShowQueueTab = computed(() => {
      return isQueueModuleActive.value
    })

    const setActivePassState = (status) => {
      store.commit("dashboardTable/UPDATE_STATUS", status)
    }

    return {
      activePassState,
      isAppoinmentMode,
      shouldShowBothTab,
      shouldShowEndedTab,
      shouldShowQueueTab,
      setActivePassState
    }
  }
}
</script>

<style scoped>
.filter-tab-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  font-size: 12px;
}
</style>
